import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { filter, find, orderBy, reduce } from 'lodash'
import SiteTypes from '../../../utils/mapUtils/SiteTypes'
import { formatNumber } from '../../../utils/NumberUtils'
import UUID from 'uuid'
import { Avatar, List, ListItem } from '@material-ui/core'
import { getDate } from '../../../utils/DateUtil'
import i18n from 'simple-react-i18n'
import DtoStation from '../../../sites/dto/DtoStation'
import DtoKeyFigures from '../../../sites/dto/DtoKeyFigures'
import DtoType from '../../../referential/dto/DtoSiteType'
import DtoPoint from '../../dto/DtoPoint'

class PointProximityPanel extends Component {

	constructor(props) {
		super(props)
	}

	getLeftAvatar = (referenceType) => {
		return (
			<Avatar size={ 40 } src={ referenceType.icon } style={ {
				width: 'auto',
				backgroundColor: 'none'
			} }/>
		)
	}

	getSecondaryText = (station) => {
		const keyFigureStation = find(this.props.keyFigures, (o) => {
			return o.stationId == station.id && o.typeId == this.props.siteType.id
		})
		if (keyFigureStation && keyFigureStation.endDate) {
			const nbData = keyFigureStation.nbAnalysis ? keyFigureStation.nbAnalysis : keyFigureStation.nbMeasure
			return nbData + ' - ' + i18n.of + ' ' + getDate(keyFigureStation.beginDate) + ' ' + i18n.to + ' ' + getDate(keyFigureStation.endDate)
		}
		return ''
	}

	getData = () => {
		if (this.props.proximityStation) {
			const filterByTypes = reduce(filter(this.props.proximityStation, (o) => {
				return o.station.id != this.props.point.id
			}), (result, value) => {
				const tmpType = SiteTypes.getType(value.station.typeId, this.props.siteTypes)
				if (result[tmpType.type] || (result[tmpType.type] = [])) {
					(result[tmpType.type] || (result[tmpType.type] = [])).push(value)
				}
				return result
			}, {})
			const result = orderBy(Object.keys(filterByTypes).map((type) => {
				if (filterByTypes[type].length) {
					const stationOrder = orderBy(filterByTypes[type], 'distance', 'asc')[0]
					const stationSelected = stationOrder.station
					const referenceType = SiteTypes[type]
					return {
						stationSelected: stationSelected,
						referenceType: referenceType,
						distance: stationOrder.distance
					}
				}
				return null
			}), 'distance', 'asc')

			return result.map((o) => {
				return (
					<div key={ UUID.v4() } className={ 'col s12 no-padding' }>
						<ListItem key={ UUID.v4() } primaryText={ o.stationSelected.name } secondaryText={ this.getSecondaryText(o.stationSelected) }
								  leftAvatar={ this.getLeftAvatar(o.referenceType) }
								  rightAvatar={
									  <Avatar size={ 50 } style={ { fontSize: '5px !important' } }>
										  { formatNumber(o.distance) + ' km' }
									  </Avatar>
								  }/>
					</div>
				)
			})
		}
		return null
	}

	render() {
		return (
			<div className='row no-margin card'>
				<div className='card-padding'>
					<div className='card-title no-padding no-margin-bottom'>
						<h6 className='aquadb-title'>{ i18n.proximityPoints }</h6>
					</div>
					<div className='card-content no-padding'>
						<div className={ 'row no-margin' }>
							<List>
								{ this.getData() }
							</List>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

PointProximityPanel.propTypes = {
	proximityStation: PropTypes.shape(PropTypes.objectOf({
		distance: PropTypes.number,
		station: PropTypes.instanceOf(DtoStation)
	})),
	siteType: PropTypes.objectOf(DtoType),
	point: PropTypes.objectOf(DtoPoint),
	siteTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoType)),
	keyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures))
}
const mapStateToProps = store => {
	return {
		point: store.PointReducer.point,
		pointKeyFigures: store.PointReducer.pointKeyFigures,
		siteTypes: store.ReferentialReducer.siteTypes,
		keyFigures: store.SitesReducer.keyFigures
	}
}

export default connect(mapStateToProps)(PointProximityPanel)



// WEBPACK FOOTER //
// ./src/point/components/proximity/PointProximityPanel.js